import { render, staticRenderFns } from "./taxi-ride-drawer.vue?vue&type=template&id=608ff878&scoped=true"
import script from "./taxi-ride-drawer.vue?vue&type=script&lang=js"
export * from "./taxi-ride-drawer.vue?vue&type=script&lang=js"
import style0 from "./taxi-ride-drawer.vue?vue&type=style&index=0&id=608ff878&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608ff878",
  null
  
)

export default component.exports